import { Navigate } from 'react-router-dom';
import { ReactElement } from 'react';

type AdminContainerProps = {
  children: ReactElement;
  redirect?: boolean;
  allowInternal?: boolean;
};

const AdminContainer = (props: AdminContainerProps) => {
  const permittedInternalUser =
    props.allowInternal && window.settings.role === 'internal_user';
  if (!window.settings.admin && !permittedInternalUser) {
    return props.redirect ? <Navigate to="/" /> : null;
  }

  return props.children;
};

export default AdminContainer;
